import React, { useState, useEffect } from 'react';
import biomelogo from '../../Assets/photo/biomelogo.png';
import './CensorCompliance.css';

const CensorCompliance = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('show');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    reveals.forEach((el) => io.observe(el));

    return () => {
      reveals.forEach((el) => io.unobserve(el));
    };
  }, []);

  return (
    <div className="censor-compliance-container">
      {/* HEADER */}
      <header>
        <div className="container nav">
          <div className="brand">
            <img src={biomelogo} alt="BioME Logo" />
            <strong>BioME Compliance</strong>
          </div>
          <nav className="nav-desktop">
            <a href="/#features">Features</a>
            <a href="/page/allfeatures">All Features</a>
            <a href="/page/news">News</a>
            <a href="/#pricing">Pricing</a>
            <a href="/#faq">FAQ</a>
            <a className="btn" href="/auth/signup">Create</a>
          </nav>
          <button className="mobile-menu-btn" onClick={handleMobileMenuToggle}>☰</button>
        </div>

        {/* MOBILE MENU */}
        <div className={`mobile-menu ${mobileMenuOpen ? 'active' : ''}`}>
          <button className="close-btn" onClick={closeMobileMenu}>×</button>
          <div className="mobile-nav">
            <a href="/#features" onClick={closeMobileMenu}>Features</a>
            <a href="/page/allfeatures" onClick={closeMobileMenu}>All Features</a>
            <a href="/page/news" onClick={closeMobileMenu}>News</a>
            <a href="/#pricing" onClick={closeMobileMenu}>Pricing</a>
            <a href="/#faq" onClick={closeMobileMenu}>FAQ</a>
            <a href="/auth/signup" onClick={closeMobileMenu} className="mobile-cta">Create My BioME</a>
          </div>
        </div>
      </header>

      {/* HERO */}
      <section className="hero reveal">
        <div className="container">
          <h1>Content Compliance & Access Control</h1>
          <p>Protect your audience, your exclusives, and your reputation — responsibly.</p>
        </div>
      </section>

      {/* COMPLIANCE */}
      <section className="compliance reveal">
        <div className="container">
          <h2>Responsible Publishing on BioME</h2>
          <p>
            Adhere to{' '}
            <a href="/page/censorcompliance" style={{ textDecoration: 'underline', color: '#7a0bc0', fontWeight: '600' }}>
              community guidelines
            </a>{' '}
            when posting private or exclusive content. Always secure your shared media — whether they are unreleased artworks, limited edition drops, behind-the-scenes materials, or any private visuals.
          </p>

          <div className="notice-box">
            <h3>Core Principle</h3>
            <p>
              Your BioME account represents your creative space. Guard your links, images, audio files, and restricted media with appropriate age prompts, password or PIN access, and clear context so your audience understands what they're viewing.
            </p>
          </div>

          <h2>Good Practices for Secure Sharing</h2>
          <ul>
            <li><strong>Age or Access Prompts:</strong> For sensitive or premium content, ensure there's an access layer (e.g., "18+ only" or "members-only").</li>
            <li><strong>Password / PIN Gate:</strong> Protect unreleased or private drops with password entry when necessary.</li>
            <li><strong>Exclusive Releases:</strong> Label limited edition, invite-only, or early-release materials clearly.</li>
            <li><strong>Copyright Integrity:</strong> Only upload or embed media you own or have permission to share.</li>
            <li><strong>Privacy & Consent:</strong> Never post identifiable personal data, images, or recordings without consent.</li>
            <li><strong>Safe Linking:</strong> When connecting to third-party storage or external media, verify their safety and compliance.</li>
            <li><strong>Transparency:</strong> Include content disclaimers or descriptions where context is important (e.g., work-in-progress visuals or mature imagery).</li>
          </ul>

          <h2>Compliance Review & Enforcement</h2>
          <p>
            BioME's automated and human moderation systems monitor shared content for safety and community alignment. Accounts repeatedly violating these standards may be restricted or suspended.
          </p>

          <p>
            Remember, compliance protects not just your viewers — it protects your creative reputation and the sustainability of BioME as a safe discovery space.
          </p>
        </div>
      </section>

      {/* FOOTER */}
      <footer>
        <div className="container foot">
          <img src={biomelogo} alt="BioME Logo" />
          <div style={{ display: 'flex', gap: '18px', flexWrap: 'wrap', justifyContent: 'center' }}>
            <a href="/#features">Features</a>
            <a href="/page/allfeatures">All Features</a>
            <a href="/page/news">News</a>
            <a href="/#pricing">Pricing</a>
            <a href="/#faq">FAQ</a>
          </div>
          <small>© {new Date().getFullYear()} BioME.com. All rights reserved.</small>
        </div>
      </footer>
    </div>
  );
};

export default CensorCompliance;
